<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0V1.33333H13.724L10.3906 4.66667L11.3333 5.60933L14.6666 2.276V4H16V0H12Z" fill="#080828"/>
<path d="M4 0V1.33333H2.276L5.60933 4.66667L4.66667 5.60933L1.33333 2.276V4H0V0H4Z" fill="#080828"/>
<path d="M12 16V14.6667H13.724L10.3906 11.3334L11.3333 10.3907L14.6666 13.724V12H16V16H12Z" fill="#080828"/>
<path d="M4 16V14.6667H2.276L5.60933 11.3334L4.66667 10.3907L1.33333 13.724V12H0V16H4Z" fill="#080828"/>
</svg>
